import { SetStateAction } from "react";
import { SecondaryColor, NeutralColor } from "node-library/dist/colors";
import React from "react";

interface StepsBarProps {
	items: Array<string>;
	currentItem: number;
	setCurrentItem: React.Dispatch<SetStateAction<number>>;
}

function StepsBar(props: StepsBarProps): JSX.Element {
	const { items, currentItem, setCurrentItem } = props;

	const content: Array<React.ReactNode> = items.map((text, index) => {
		return (
			<React.Fragment key={index}>
				{index !== 0 && (
					<hr
						className="step-bar-item step-bar-line"
						style={{ width: 100 / (items.length * 2 - 1) + "%" }}
					></hr>
				)}
				<div
					className="step-bar-item typography-body-02"
					style={{
						display: "flex",
						alignItems: "center",
						color:
							index === currentItem
								? SecondaryColor.SECONDARY_LV10
								: NeutralColor.NEUTRAL_GREY_300,
						gap: "5px",
					}}
				>
					<div
						style={{
							color: "white",
							backgroundColor:
								index === currentItem
									? SecondaryColor.SECONDARY_LV10
									: NeutralColor.NEUTRAL_GREY_300,
							borderRadius: "25px",
							width: "26px",
							minWidth: "26px",
							height: "26px",
							minHeight: "26px",
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<div>{index + 1}</div>
					</div>

					<div style={{ maxWidth: "200px" }}>{text}</div>
				</div>
			</React.Fragment>
		);
	});

	return <div className="step-bar">{content}</div>;
}

export { StepsBar };
